import classNames from 'classnames';
import React, { lazy } from 'react';
import rehypeRaw from 'rehype-raw';
import type { PluggableList } from 'unified';

const ReactMarkdown = lazy(() => import('react-markdown'));

type TextMarkdownPropTypes = {
    text: string;
    className?: string;
    mode?: 'dark' | 'light';
};
// rest includes inspectorProps props for live preview
export const TextMarkdown = (props: TextMarkdownPropTypes) => {
    const { text, mode = 'light', className = '', ...rest } = props;

    const modeClasses = classNames({
        'prose-invert': mode === 'dark',
    });

    return (
        <div {...rest} className={`prose prose-lg md:prose-xl ${modeClasses} ${className}`}>
            <ReactMarkdown rehypePlugins={[rehypeRaw] as PluggableList}>{text}</ReactMarkdown>
        </div>
    );
};

export default TextMarkdown;
